<template>
  <div v-if="loading">
    <Loader />
  </div>
  <section class="trending  position-relative package-section" v-else>
    <div class="row y-gap-20 justify-between items-center">
      <div data-aos="fade-up" :data-aos-delay="200" class="row y-gap-20 justify-between items-center">
        <div>
          <div class="sectionTitle mb-30">
            <h2 class="sectionTitle__title">{{ $t('trending_courses') }}</h2>
            <p class="sectionTitle__text">{{ $t('what_everyone_is_learning') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-6 mb-15 d-flex flex-column" v-for="course in TrendingCourses" :key="course.uuid">
        <Coursecard :showPrice="true" :item="course" />
      </div>
    </div>
    <!----<carousel v-bind="settings" :breakpoints="breakpoints" :autoplay="5000" :wrap-around="true" :dir="direction">
      <slide v-for="slide in TrendingCourses" :key="slide.uuid" class="mb-15 px-1">
        <Coursecard :showPrice="true" :item="slide" />
      </slide>

      <template #addons>
        <pagination />
      </template>
</carousel>-->
  </section>
</template>

<style lang="scss" scoped>
.trending {
  // scroll-margin-top: 140px; 
  padding-top: 50px;
}
</style>

<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import AOS from "aos";
//import "vue3-carousel/dist/carousel.css";
//import { Carousel, Slide, Pagination } from "vue3-carousel";
import Coursecard from "../common/Coursecard.vue";
//import { getLatestCourses } from "@/Services/api/CoursesService";
import { mapGetters } from "vuex";
import Loader from "../common/Loader.vue";
export default {
  components: {
    Loader,
    /* Carousel,
     Slide,
     Pagination,*/
    Coursecard,
  },
  props: {
    TrendingCourses: {
      type: Array
    }
  },
  data() {
    /*return {
      direction: localStorage.getItem("direction") || "ltr",
      loading: false,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 1,
          snapAlign: "left",
        },
        900: {
          itemsToShow: 2,
          snapAlign: "left",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "left",
        },
      } 
    };*/
  },
  methods: {
    /*async getRecentCourse() {
      this.loading = true
      try {
        const response = await getLatestCourses();
        this.TrendingCourses = response.data;
      } catch (error) {
        console.log(error.message)
      } finally {
        this.loading = false
      }
    }*/
  },
  computed: {
    ...mapGetters(['currentLanguage']),
    userData() {
      return this.$store.getters.userData;
    },
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        //  this.language = newLang;
        // this.getRecentCourse();
      },
      immediate: true, // Run the handler immediately when the component is mounted
    }
  },
  mounted() {
    window.addEventListener("direction-localstorage-changed", (event) => {
      this.direction = event.detail.storage;
    });

    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
